import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
var _AppsIcon;
import AnalyticFeedsIcon from '@apps-common/ui-icons/AnalyticFeeds.js';
import BasemapViewerIcon from '@apps-common/ui-icons/BasemapViewer.js';
import DevCenterIcon from '@apps-common/ui-icons/DevCenter.js';
import ExplorerIcon from '@apps-common/ui-icons/Explorer.js';
import React, { useMemo } from 'react';
import SentinelHubIcon from '@apps-common/ui-icons/Sentinelhub.js';
import SinergiseIcon from '@apps-common/ui-icons/Sinergise.js';
import StoriesIcon from '@apps-common/ui-icons/Stories.js';
import TaskingIcon from '@apps-common/ui-icons/TaskingDashboard.js';
import AppsIcon from "@mui/icons-material/esm/Apps.js";
import MenuItem from "@mui/material/MenuItem/MenuItem.js";
import ListItemIcon from "./ListItemIcon.js";
import NavMenuButton from "./NavMenuButton.js";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var APPS = [{
  title: 'Planet Explorer',
  subtitle: 'Explore Planet data',
  href: 'https://www.planet.com/explorer',
  icon: /*#__PURE__*/_jsx(ExplorerIcon, {}),
  key: 'explorer'
}, {
  title: 'Planet Stories',
  subtitle: 'Share timelapse comparisons',
  href: 'https://www.planet.com/stories',
  icon: /*#__PURE__*/_jsx(StoriesIcon, {}),
  key: 'stories'
}, {
  title: 'Basemaps Viewer',
  subtitle: 'Recent and ready to integrate',
  href: 'https://www.planet.com/basemaps',
  icon: /*#__PURE__*/_jsx(BasemapViewerIcon, {}),
  key: 'basemapsViewer'
}, {
  title: 'Tasking Dashboard',
  subtitle: 'High-res imagery upon request',
  href: 'https://www.planet.com/tasking',
  icon: /*#__PURE__*/_jsx(TaskingIcon, {}),
  key: 'tasking'
}, {
  title: 'Analytic Feeds',
  subtitle: '',
  href: 'https://www.planet.com/feeds',
  icon: /*#__PURE__*/_jsx(AnalyticFeedsIcon, {}),
  key: 'feedsViewer'
}, {
  title: 'Developer Center',
  subtitle: 'Plug into your Planet',
  href: 'https://developers.planet.com/',
  icon: /*#__PURE__*/_jsx(DevCenterIcon, {}),
  key: 'devCenter'
}];
var SENTINEL_HUB_APPS = [{
  title: 'Sentinel Hub Dashboard',
  subtitle: 'Manage your Sentinel Hub account, collections, and monitor usage',
  href: 'https://apps.sentinel-hub.com/dashboard/?kc_idp_hint=planet-account-link',
  icon: /*#__PURE__*/_jsx(SentinelHubIcon, {}),
  key: 'sentinelhub'
}, {
  title: 'EO Browser',
  subtitle: 'Browse and compare images',
  href: 'https://apps.sentinel-hub.com/eo-browser/?kc_idp_hint=planet-account-link',
  icon: /*#__PURE__*/_jsx(SinergiseIcon, {}),
  key: 'eobrowser'
}];

/**
 * Menu with links to Planet web applications. Used in `NavBar` component, but can be imported as a standalone component as well.
 */
var AppsMenu = function AppsMenu(_ref) {
  var exclude = _ref.exclude,
    includeSentinelHubApps = _ref.includeSentinelHubApps;
  // Exclude app(s) from menu
  var filteredApps = useMemo(function () {
    var apps = [];
    if (Array.isArray(exclude)) {
      apps = APPS.filter(function (app) {
        return exclude.indexOf(app.key) < 0;
      });
    } else {
      apps = APPS.filter(function (app) {
        return app.key !== exclude;
      });
    }
    return includeSentinelHubApps ? [].concat(_toConsumableArray(apps), SENTINEL_HUB_APPS) : apps;
  }, [exclude, includeSentinelHubApps]);
  return /*#__PURE__*/_jsx(NavMenuButton, {
    title: "Applications Menu",
    label: _AppsIcon || (_AppsIcon = /*#__PURE__*/_jsx(AppsIcon, {
      fontSize: "small"
    })),
    "data-qe": "application-menu-button",
    "aria-label": "Planet Applications",
    children: filteredApps.map(function (app) {
      return /*#__PURE__*/_jsxs(MenuItem, {
        title: app.subtitle,
        component: "a",
        target: "_blank",
        rel: "noreferrer noopener",
        href: app.href,
        "data-qe": "".concat(app.key, "-menu-item"),
        children: [/*#__PURE__*/_jsx(ListItemIcon, {
          sx: {
            color: 'text.primary'
          },
          children: app.icon
        }), ' ', app.title]
      }, app.key);
    })
  });
};
AppsMenu.defaultProps = {
  includeSentinelHubApps: false
};
export default AppsMenu;